import { Provider } from '@angular/core';

import { AbstractLogger, LoggerFactory } from './abstract';

export class MockLoggerService {
	createLogger(name: string): AbstractLogger {
		return {
			error() {},
			log() {},
			info() {},
			warn() {},
			trace() {},
			write() {},
			forceLogInfo() {},
			createOptions(o) {
				return o;
			},
			disable() {},
			enable() {},
			group() {},
			groupCollapsed() {},
			groupEnd() {},
			name: null,
			enabled: false,
		};
	}
}

export const mockLoggerServiceProvider: Provider = {
	provide: LoggerFactory,
	useClass: MockLoggerService,
};
